import { render, staticRenderFns } from "./BrimolaClearing.vue?vue&type=template&id=4e258488"
import script from "./BrimolaClearing.vue?vue&type=script&lang=js"
export * from "./BrimolaClearing.vue?vue&type=script&lang=js"
import style0 from "./BrimolaClearing.vue?vue&type=style&index=0&id=4e258488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports